import { Sheet } from './Sheet.js';
import styles from './PickDetail.module.css';

export interface PickDetailData {
  categoryName: string;
  itemName: string;
  itemDescription?: string | undefined;
  itemImageUrl?: string | undefined;
}

/**
 * Pick 하나를 크게 보여주는 읽기 전용 시트.
 *
 * 격자로 바꾸면서 **한 줄 설명이 화면에서 사라졌다.** "왜 이걸 골랐는지"가
 * 이 서비스의 알맹이라 볼 방법이 없으면 안 된다. 칸을 누르면 여기서 보여준다.
 */
export function PickDetail({
  pick,
  onClose,
}: {
  pick: PickDetailData | null;
  onClose: () => void;
}) {
  const hasImage = pick?.itemImageUrl !== undefined && pick.itemImageUrl !== '';

  return (
    <Sheet
      open={pick !== null}
      onClose={onClose}
      title={pick?.itemName ?? ''}
      lead={pick?.categoryName ?? ''}
    >
      {pick === null ? null : (
        <div>
          {hasImage ? <img className={styles.image} src={pick.itemImageUrl} alt="" /> : null}
          {pick.itemDescription !== undefined && pick.itemDescription !== '' ? (
            <p className={styles.quote}>“{pick.itemDescription}”</p>
          ) : null}
        </div>
      )}
    </Sheet>
  );
}
